import { AiState, DocTargetFragment } from '@cycle-app/graphql-codegen';

const VERIFIED_QUOTE_TEMP_PREFIX = 'verified-quote-temp-';

export const getVerifiedQuoteTempId = () => `${VERIFIED_QUOTE_TEMP_PREFIX}-${Date.now()}`;

export const isVerifiedQuote = (
  insight: DocTargetFragment,
) => insight.doc?.aiState === AiState.UserValidated || insight.id.startsWith(VERIFIED_QUOTE_TEMP_PREFIX);
